import React from "react";
import { CFormCheck, CFormLabel } from "@coreui/react";
import {
  DEFAULT_DANGEROUS_EVENT_TYPES,
  SELECTABLE_DANGEROUS_EVENT_TYPES,
  formatDangerousEventType,
} from "../../utils/dangerousEventTypes";

export default function EventTypeFilter({ selected = [], onChange }) {
  const toggle = (type) => {
    const set = new Set(selected);
    if (set.has(type)) set.delete(type);
    else set.add(type);
    onChange([...set]);
  };

  const useDefaults = () => onChange([]);
  const selectAll = () => onChange([...SELECTABLE_DANGEROUS_EVENT_TYPES]);

  return (
    <div className="mb-3">
      <CFormLabel>Типы событий</CFormLabel>
      <div className="d-flex flex-wrap gap-2 mb-2">
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={useDefaults}>
          По умолчанию ({DEFAULT_DANGEROUS_EVENT_TYPES.length})
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={selectAll}>
          Все типы
        </button>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => onChange([])}>
          Сбросить выбор
        </button>
      </div>
      <div className="row g-2">
        {SELECTABLE_DANGEROUS_EVENT_TYPES.map((type) => (
          <div key={type} className="col-12 col-md-6 col-lg-4">
            <CFormCheck
              id={`evt-${type}`}
              label={formatDangerousEventType({ type })}
              checked={selected.includes(type)}
              onChange={() => toggle(type)}
            />
          </div>
        ))}
      </div>
      {selected.length === 0 && (
        <small className="text-body-secondary d-block mt-2">
          Не выбрано — используются типы по умолчанию на сервере.
        </small>
      )}
    </div>
  );
}
